// src/components/MirrorHero.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/components/MirrorHero.css";

import IconPng from "../components/IconPng";

import heroBg from "../img/hero/mirror-hero-bg.webp";
import arrowCircle from "../img/hero/arrow-circle-2.png";
import arrowCircle_2 from "../img/hero/arrow-circle-3.png";  

export default function MirrorHero() {
  const navigate = useNavigate();

  return (
    <section className="mega-hero" aria-label="Showcase">
      {/* Дзеркальне зображення */}
      <img className="mega-hero__bg" src={heroBg} alt="" aria-hidden="true" />

      {/* Скляна плашка по центру */}
      <div className="mega-hero__glass">
        <h1 className="mega-hero__title">Thank You!</h1>
        <p className="mega-hero__subtitle">
          Your submission has been received.<br />
          We’ll get back to you as soon as possible.
        </p>

        {/* Дві кнопки */}
        <div className="mega-hero__cta">
          <button
            type="button"
            className="Primary v2 mega-hero__btn"
            onClick={() => navigate("/")}
          >
            <span>Go to Homepage</span>
            <img src={arrowCircle} alt="" aria-hidden="true" />
          </button>

          <button
            type="button"
            className="Primary v3 mega-hero__btn"
            onClick={() => navigate("/cases")}
          >
            <span>Check our portfolio</span>
            <img src={arrowCircle_2} alt="" aria-hidden="true" />
          </button>
        </div>

        {/* Соцмережі */}
        <div className="ftr__social mega-hero__social" aria-label="Social links">
          <a
            href="https://x.com/your"
            className="ftr-social__btn"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="X / Twitter"
          >
            <IconPng name="X" size={40} />
          </a>
          <a
            href="https://t.me/your"
            className="ftr-social__btn"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Telegram"
          >
            <IconPng name="Telegram" size={40} />
          </a>
          <a
            href="https://www.linkedin.com/company/intelligent-writing/"
            className="ftr-social__btn"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
          >
            <IconPng name="LinkedIn" size={40} />
          </a> 
        </div>
      </div>
    </section>
  );
}
